import { Link } from '@bb-ui/react-library/dist/components/Link/Link';
import { Typography } from '@bb-ui/react-library/dist/components/Typography/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from './UserList.styles';
import { Message } from '../../../Message/Message';
import { useHelpLinks } from '../../../../hooks/useHelpLinks';

export const UserListError = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const getHelpLink = useHelpLinks();

    return (
        <>
            <Typography
                component="p"
                className={classes.description}
                data-testid="description"
            >
                {t('settings.licenseManagement.description')}
            </Typography>
            <div data-testid="user-list-error" className={classes.errorMessage}>
                <Message
                    variant="error"
                    message={t('general.contentError')}
                    secondaryMessage={t('general.contentErrorRefresh', {
                        action: (
                            <Link
                                href={getHelpLink('contactSupport')}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="data-q-and-a-help-link"
                            >
                                {t('general.contactSupportAction')}
                            </Link>
                        ),
                    })}
                />
            </div>
        </>
    );
};
